var Backbone, SupportAppRouter, SupportHelpWizardController, directlyAccessed, handleAbruptStepTwoFlow, hideComponents,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SupportHelpWizardController = require('./helpWizardController');

SupportAppRouter = (function(superClass) {
  extend(SupportAppRouter, superClass);

  function SupportAppRouter() {
    return SupportAppRouter.__super__.constructor.apply(this, arguments);
  }

  SupportAppRouter.prototype.routes = {
    '': 'initialRedirection',
    'pick-order': 'renderStepOne',
    'select-issue': 'renderStepTwo',
    'contact-us': 'renderStepThree',
    'problem-solved': 'renderProblemSolved',
    'ticket-success': 'renderTicketSuccess',
    'chat-success': 'renderChatSuccess'
  };

  SupportAppRouter.prototype.initialRedirection = function() {
    if (window.isFromCostcoFaq) {
      Groupon.Support.ORDER_NOT_LISTED = true;
      Backbone.history.navigate('#contact-us', {
        trigger: true
      });
      return false;
    }
    if (window.landingStep != null) {
      if (window.landingStep === "intermediate_page") {
        return this.renderIntermediatePage();
      } else if (window.landingStep === "step_1") {
        return SupportHelpWizardController.initOrdersFetch();
      } else if (window.landingStep === "step_2") {
        return handleAbruptStepTwoFlow();
      }
    } else {
      return handleAbruptStepTwoFlow();
    }
  };

  SupportAppRouter.prototype.renderIntermediatePage = function() {
    return SupportHelpWizardController.intermediatePage();
  };

  SupportAppRouter.prototype.renderStepOne = function() {
    if (!Groupon.Support.OrdersCollection.hasOrders()) {
      return Backbone.history.navigate('', {
        trigger: true
      });
    }
    if (directlyAccessed()) {
      return Backbone.history.navigate('', {
        trigger: true
      });
    }
    hideComponents();
    return SupportHelpWizardController.stepOne(Groupon.Support.currentOrder);
  };

  SupportAppRouter.prototype.renderStepTwo = function() {
    if (directlyAccessed()) {
      return Backbone.history.navigate('', {
        trigger: true
      });
    }
    hideComponents();
    return SupportHelpWizardController.stepTwo();
  };

  SupportAppRouter.prototype.renderStepThree = function() {
    if (directlyAccessed()) {
      return Backbone.history.navigate('', {
        trigger: true
      });
    }
    hideComponents();
    return SupportHelpWizardController.stepThree();
  };

  SupportAppRouter.prototype.renderProblemSolved = function() {
    if (directlyAccessed()) {
      return Backbone.history.navigate('', {
        trigger: true
      });
    }
    hideComponents();
    return SupportHelpWizardController.problemSolved();
  };

  SupportAppRouter.prototype.renderTicketSuccess = function() {
    if (directlyAccessed()) {
      return Backbone.history.navigate('', {
        trigger: true
      });
    }
    hideComponents();
    return SupportHelpWizardController.ticketSuccess();
  };

  SupportAppRouter.prototype.renderChatSuccess = function() {
    if (directlyAccessed()) {
      return Backbone.history.navigate('', {
        trigger: true
      });
    }
    hideComponents();
    return SupportHelpWizardController.chatSuccess();
  };

  return SupportAppRouter;

})(Backbone.Router);

handleAbruptStepTwoFlow = function() {
  var listener;
  if (!isCMSEnabled() && Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()) {
    listener = function() {
      $(document).off("inbenta-help-wizard-loaded", listener);
      return SupportHelpWizardController.abruptStepTwoFlow();
    };
    return $(document).on('inbenta-help-wizard-loaded', listener);
  } else {
    return SupportHelpWizardController.abruptStepTwoFlow();
  }
};

directlyAccessed = function() {
  return !((Groupon.Support.currentOrder != null) || (Groupon.Support.NOT_ORDER_RELATED != null) || (Groupon.Support.ORDER_NOT_LISTED != null));
};

hideComponents = function() {
  return window.hideFooterLinks();
};

module.exports = SupportAppRouter;

//# sourceMappingURL=data:application/json;base64,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
